module.exports = new __parcel__URL__("add-comment.7214acf1.svg").toString();